<template>
  <w-toast :toasts="plugin.state.messages" />
</template>
<script setup lang="ts">
import { WToast } from '@dp-watson-web/components';

import { useToastMessagesPlugin } from '../providers';

const plugin = useToastMessagesPlugin();
</script>
